export default class BusinessUnit {
  id: number
  name: string
  code: string
  tin: string
  description?: string
  created: string
  image: string

  constructor(props: BusinessUnit) {
    Object.assign(this, props)
    this.image = props.image + '?dummy=' + makeid(3)
  }
}

export const makeid = (length) => {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/BusinessUnits/Model.ts